var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bar-chart',{ref:"chart",attrs:{"options":_vm.options,"chart-data":_vm.chartData,"chart":_vm.chart},on:{"update:chart":function($event){_vm.chart=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }